import { DesignTokens } from '../brands';

export const transparentWhite = 'rgba(255, 255, 255, 0.24)';

const dsTokens: DesignTokens = {
  media: {
    mobile: '(min-width: 520px)',
    tablet: '(min-width: 768px)',
    desktop: '(min-width: 992px)',
    fullscreen: '(min-width: 1200px)',
    ultrawide: '(min-width: 1400px)',
    motion: '(prefers-reduced-motion)',
    hover: '(any-hover: hover)',
    dark: '(prefers-color-scheme: dark)',
    light: '(prefers-color-scheme: light)',
  },
  colors: {
    '1': '#FF0801',
    '2': '#FF5501',
    '3': '#E29500',
    '4': '#A7B820',
    '5': '#6CD115',
    '6': '#20AE43',
    '7': '#1FA685',
    '8': '#49B1BF',
    '9': '#1B57CE',
    '10': '#7E15E3',
    '11': '#FF01B1',
    '12': '#FF0162',
    'brand-1': '#613A53',
    'brand-2': '#A98862',
    'brand-3': '#F1F2F2',
    'dark-dark': '#383840',
    'dark-light': '#383840',
    'light-dark-1': '#F5F5F5',
    'light-dark-2': '#FFFFFF',
    'light-light': '#FFFFFF',
    'medium-light-1': '#515151',
    'medium-light-2': '#CCCCCC',
    'medium-medium': '#878787',
    actionNavigationStandardStatic: '#A98862',
    actionNavigationStandardHighlight: '#8B6A44',
    actionNavigationStandardDisabled: '#00000029',
    actionNavigationAltStatic: '#FFFFFF',
    actionNavigationAltHighlight: '#C7A67C',
    actionNavigationAltDisabled: '#ffffff3d',
    actionNavigationWarningStatic: '#DE1616',
    actionNavigationWarningHighlight: '#FF6666',
    actionNavigationWarningDisabled: transparentWhite,
    actionConversionStatic: '#A2577C',
    actionConversionHighlight: '#613A53',
    actionConversionDisabled: '#00000029',
    actionSuccessStatic: '#0DAB01',
    actionSuccessHighlight: '#005800',
    actionSuccessDisabled: transparentWhite,
    actionAlertStatic: '#FF9700',
    actionAlertHighlight: '#c66800',
    actionAlertDisabled: transparentWhite,
    'error-standard': '#DE1616',
    'error-alt': '#FF6666',
    'success-standard': '#0DAB01',
    'success-alt': '#70DD67',
    'alert-standard': '#FF9700',
    'alert-alt': '#FBC679',
    whatsapp: '#128C7E',
    facebook: '#0078FF',
    'gradient-1': '#1174AB',
    'gradient-2': '#96308F',
    'gradient-3': '#8EC740',
    'gradient-4': '#3E9559',
    overlay: 'rgba(0, 0, 0, 0.3)',
    disabledDark: 'rgba(0, 0, 0, 0.16)',
    disabled: transparentWhite,
    background: '#FFFFFF',
    shadowLight: 'hsl(206 22% 7% / 35%)',
    shadowDark: 'hsl(206 22% 7% / 20%)',
    nonInteractiveEmphasis: '#496954',
  },
  fonts: {
    primary: "'Sofia Pro', Helvetica, Arial, sans-serif",
    secondary: "'Sofia Pro', Helvetica, Arial, sans-serif",
  },
  sizes: {
    '0': '0rem',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '13': '3.25rem',
    '14': '3.5rem',
    '15': '3.75rem',
    '16': '4rem',
    '17': '4.25rem',
    '18': '4.5rem',
    '19': '4.75rem',
    '20': '5rem',
    '21': '5.25rem',
    '22': '5.5rem',
    '23': '5.75rem',
  },
  space: {
    '0': '0rem',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '13': '3.25rem',
    '14': '3.5rem',
    '15': '3.75rem',
    '16': '4rem',
    '17': '4.25rem',
    '18': '4.5rem',
    '19': '4.75rem',
    '20': '5rem',
    '21': '5.25rem',
    '22': '5.5rem',
    '23': '5.75rem',
    '24': '13.75rem',
  },
  fontSizes: {
    xxs: '0.5rem',
    xs: '0.625rem',
    sm: '0.75rem',
    md: '0.875rem',
    lg: '1rem',
    xl: '1.125rem',
    xxl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '2.25rem',
    '4xl': '3rem',
    '5xl': '4.5rem',
    '6xl': '6rem',
    '7xl': '8rem',
  },
  shadows: {
    downSoft: '0px 4px 20px 0px rgba(0, 0, 0, 0.12)',
    downClose: '0px 4px 8px -4px rgba(0, 0, 0, 0.32)',
    downMid: '0px 4px 24px -8px rgba(0, 0, 0, 0.4)',
    downFar: '0px 8px 24px -8px rgba(0, 0, 0, 0.4)',
    upSoft: '0px -4px 20px 0px rgba(0, 0, 0, 0.12)',
    upMid: '0px -4px 24px -8px rgba(0, 0, 0, 0.4)',
    rightMid: '4px 0px 24px -8px rgba(0, 0, 0, 0.4)',
    leftMid: '-4px 0px 24px -8px rgba(0, 0, 0, 0.4)',
    outline: '0 0 0 2px rgba(0, 120, 255, 0.8)',
  },
  letterSpacings: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em',
  },
  lineHeights: {
    normal: 1.2,
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: 2,
  },
  fontWeights: {
    regular: 500,
    medium: 500,
    heavy: 600,
    light: 300,
    strong: 'bolder',
  },
  borderWidths: {
    none: 0,
    hairline: '1px',
    thin: '2px',
    medium: '4px',
    thick: '8px',
  },
  radii: {
    sharp: '0px',
    small: '4px',
    medium: '8px',
    large: '16px',
    pill: '100%',
  },
  zIndices: {
    hide: -1,
    auto: 'auto',
    base: 0,
    docked: 10,
    dropdown: 1000,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800,
  },
};

export default dsTokens;
